<template>
  <transition name="fade">
    <section class="cookie-notification cookie" v-if="show">

      <h3 class="cookie__title">
        Этот сайт использует cookie для хранения данных.
      </h3>
      <p class="cookie__text">
        Продолжая использовать сайт, Вы даете свое согласие на работу с этими файлами
        <a href="#" @click="$emit('getAgreement')" class="cookie__link">Подробнее</a>
      </p>
      <button class="cookie__btn" @click="close">
        Хорошо
      </button>

    </section>
  </transition>
</template>


<script>
export default {
  name: "cookie-notification",
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    if( !localStorage.getItem('isNotifShown') ) this.show = true
  },
  methods: {
    close() {
      this.show = false
      localStorage.setItem('isNotifShown', 'true')
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.cookie {
  position: fixed;
  right: 1vw;
  bottom: 1vw;
  max-width: 400px;
  background-color: #fff;
  box-shadow:  0px 0px 6px #555;
  border-radius: 8px;
  padding: 30px;
  z-index: 99;

  &__title {
    font-size: 18px;
    line-height: 20px;
    color: #000;
  }

  &__text {
    font-size: 15px;
    margin: 1em 0;
  }

  &__link {
    color: blue;
    text-decoration: underline;
  }

  &__btn {
    width: 100%;
    font-size: 16px;
    color: #222;
    background-color: $primary;
    border: none;
    border-radius: 5px;
    padding: 0.5em;
    transition: 0.3s;
    cursor: pointer;
    
    &:hover {
      box-shadow:  1px 1px 3px #777;
    }
  }
}

@media (max-width: 1000px) {
  .cookie {
    &__title {
      font-size: 16px;
    }

    &__text {
      font-size: 14px;
    }

    &__btn {
      font-size: 15px;
    }

  }
}

@media (max-width: 640px) {
  .cookie {
    max-width: 100%;
    right: 1vw;
    padding: 15px;

    &__title {
      font-size: 12px;
      line-height: 17px;
    }

    &__text {
      font-size: 11px;
    }

    &__btn {
      font-size: 12px;
    }
  }
}
</style>
